import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { IncentiveModal } from 'wsm-incentive-modal';

import IncentivesCategorized from '../components/IncentivesCategorized';
import IncentiveDetail from '../components/IncentiveDetail';
import IncentiveWrapper from '../components/IncentiveWrapper';
import '../global-sass/main.scss';
import { filterIncentives, categorizeIncentives } from '../utils/utility';

export class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			incentive: {},
			isModalVisible: false
		};
		this.showModal = this.showModal.bind(this);
		this.hideModal = this.hideModal.bind(this);
	}

	showModal(incentive) {
		this.setState({
			incentive,
			isModalVisible: true
		});
	}

	hideModal() {
		// deliberately do not reset the incentive so that
		// that data doesn't disappear as it slides off the screen,
		// esp. for mobile dock
		this.setState({
			isModalVisible: false
		});
	}

	render() {
		let rootComponent = null;
		const { incentives, widgetInfo, account, labels, prefs } = this.props;
		// remove locale when when <Common /> is added to module
		const { windowId, widgetName, deviceType, locale } = widgetInfo;
		const isMobile = deviceType === 'MOBILE';
		const accountName = account ? account.name : null;

		if (incentives && incentives.length > 0) {
			const filteredIncentives = filterIncentives(incentives, prefs);
			const incentiveCount = filteredIncentives.length;

			if (incentiveCount) {
				// We have incentives to display

				const dialog = (
					<Common
						render={({ sitemap }) => {
							return (
								<IncentiveModal
									incentive={this.state.incentive}
									isOpen={this.state.isModalVisible}
									isMobile={isMobile}
									onModalClose={this.hideModal}
									widgetInfo={widgetInfo}
									account={account}
									newListingPath={sitemap.get(
										'INVENTORY_LISTING_DEFAULT_AUTO_NEW'
									)}
									usedListingPath={sitemap.get(
										'INVENTORY_LISTING_DEFAULT_AUTO_USED'
									)}
									// remove locale when when <Common /> is added to module
									locale={locale}
									prefs={prefs}
								/>
							);
						}}
					/>
				);
				if (incentiveCount === 1) {
					// Display single incentive
					rootComponent = (
						<div>
							<IncentiveDetail
								incentives={filteredIncentives}
								labels={labels}
								heading=""
								isMobile={isMobile}
								showModal={this.showModal}
							/>
							{dialog}
						</div>
					);
				} else if (prefs.incentiveDisplayGrouping === 'none') {
					// Display list of incentives with no headings
					rootComponent = (
						<div>
							<IncentiveWrapper
								incentiveCount={incentiveCount}
								isMobile={isMobile}
								windowId={windowId}
								widgetName={widgetName}
								labels={labels}
							>
								<IncentiveDetail
									incentives={filteredIncentives}
									labels={labels}
									heading=""
									isMobile={isMobile}
									showModal={this.showModal}
								/>
							</IncentiveWrapper>
							{dialog}
						</div>
					);
				} else {
					// Display grouped list of incentives, with headings
					rootComponent = (
						<div>
							<IncentiveWrapper
								incentiveCount={incentiveCount}
								isMobile={isMobile}
								windowId={windowId}
								widgetName={widgetName}
								labels={labels}
							>
								<IncentivesCategorized
									categorizedIncentives={categorizeIncentives(
										filteredIncentives
									)}
									separateConditional={
										prefs.incentiveDisplayGrouping ===
										'type-and-conditional'
									}
									labels={labels}
									isMobile={isMobile}
									accountName={accountName}
									showModal={this.showModal}
								/>
							</IncentiveWrapper>
							{dialog}
						</div>
					);
				}
			}
		}

		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	incentives: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			disclaimer: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool,
			make: PropTypes.string,
			condition: PropTypes.string,
			manufacturerOffer: PropTypes.bool,
			specific: PropTypes.object
		}).isRequired
	).isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		deviceType: PropTypes.string.isRequired,
		// remove locale when when <Common /> is added to module
		locale: PropTypes.string.isRequired
	}).isRequired,
	account: PropTypes.shape({
		name: PropTypes.string,
		id: PropTypes.string
	}).isRequired,
	labels: PropTypes.shape({}).isRequired,
	prefs: PropTypes.shape({
		incentiveDisplayGrouping: PropTypes.string
	}).isRequired,
	flags: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => {
	return {
		incentives: state.incentives,
		widgetInfo: state.requestData,
		account: state.account,
		labels: state.labels,
		prefs: state.prefs,
		flags: state.flags
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx